import { Messages } from '../../../../codegen/Localize';
import { ISiteSettingsForServerAdmin } from '../../../../settings/types/ISite';
import { editSite } from '../../../actions/spaces/SiteMenuActions';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const EditSiteAction: IEntityAction<ISiteSettingsForServerAdmin, {}> = {
  name: EntityActionNames.EditSiteSettings,
  translateName: Messages.editSiteSettings_action,
  isVisible: (targetItems: ISiteSettingsForServerAdmin[]) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: ISiteSettingsForServerAdmin[]) => {
    return targetItems.length === 1;
  },
  createReduxAction: (targetItems: ISiteSettingsForServerAdmin[]) => editSite(targetItems)
};
